import { render, staticRenderFns } from "./form-account.vue?vue&type=template&id=88b5727e&scoped=true"
import script from "./form-account.vue?vue&type=script&lang=js"
export * from "./form-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b5727e",
  null
  
)

export default component.exports